import { Link } from "react-router-dom";

const FAQ = () => {

    return (
        <>


            {/* <!--hero part start here!--> */}

            <section className='hearo-wrap hero-inner'>
                <div className='container'>

                    {/* <!--=========Bread Crum!=====================--> */}
                    <div className='bread-crum'>

                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">FAQ</li>
                            </ol>
                        </nav>

                    </div>
                    {/* <!--=========Bread Crum!=====================--> */}
                </div>

                <div className='container hero-bx padding-top-bot'>
                    {/* <!--exchange part!--> */}



                    <div className='row justify-content-center'>
                        <div className='col-md-7'>

                            <h1 className='hero-title top-title'>Got Questions? <br />We’ve Got Answers!</h1>

                        </div>


                    </div>
                </div>
                {/* <!--exchange part!--> */}






            </section>



            {/* <!--===================FAQ page!======================--> */}

            <section className='container faq-page sec-pad-t'>
                <div className='row justify-content-center'>
                    <div className='col-xl-7'>
                        <div className='faq-part'>
                            <h2 className='sec-title'><img src='assets/images/general.png' /> General</h2>


                            <div className='faq-quest'>

                                <div className="accordion accordion-flush" id="accordionFlushExample">
                                    <div className="accordion-item">
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                                What is Kittrow Investments s.r.o. Investments s.r.o. and how does it work?
                                            </button>
                                        </h4>
                                        <div id="flush-collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                            <div className="accordion-body">Kittrow Investments s.r.o. Investments s.r.o. is a secure platform for exchanging cryptocurrency and fiat currencies. You can easily buy crypto with your local money or sell crypto and receive fiat directly to your bank account. The process is simple: register, verify your identity, choose the currencies, send or receive funds — all in a few clicks.</div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                                                Do I need to complete identity verification (KYC)?
                                            </button>
                                        </h4>
                                        <div id="flush-collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                            <div className="accordion-body">Yes, identity verification (KYC) is required to ensure the security of all users and comply with regulatory standards. It only takes a few minutes and protects you from fraud.</div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                                                Which cryptocurrencies are supported?
                                            </button>
                                        </h4>
                                        <div id="flush-collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                            <div className="accordion-body">Kittrow Investments s.r.o. supports major cryptocurrencies like Bitcoin (BTC), Ethereum (ETH), Tether (USDT), and other popular assets. We regularly update the list to add new trusted coins.</div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapsefour" aria-expanded="false" aria-controls="flush-collapsefour">
                                                Which fiat currencies can I receive?
                                            </button>
                                        </h4>
                                        <div id="flush-collapsefour" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                            <div className="accordion-body">You can receive popular fiat currencies such as EUR (Euro), USD (US Dollar), and others, depending on your region. We aim to support more local currencies in the future.</div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapsefive" aria-expanded="false" aria-controls="flush-collapsefive">
                                                What is the minimum and maximum exchange amount?
                                            </button>
                                        </h4>
                                        <div id="flush-collapsefive" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                            <div className="accordion-body">The minimum exchange amount depends on the selected currencies but usually starts from around 20 EUR or its equivalent. The maximum amount can vary depending on verification level and payment method.</div>
                                        </div>
                                    </div>


                                </div>

                            </div>


                            {/* <!--=============================Question seprator!======================--> */}

                            <h2 className='sec-title'><img src='assets/images/process.png' /> Process & Timing</h2>
                            <div className='faq-quest'>
                                <div className="accordion accordion-flush" id="accordionFlushExample2">
                                    <div className="accordion-item">
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapsesix" aria-expanded="false" aria-controls="flush-collapseOne">
                                                How long does the exchange process take?
                                            </button>
                                        </h4>
                                        <div id="flush-collapsesix" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample2">
                                            <div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the first item’s accordion body.</div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#process1" aria-expanded="false" aria-controls="flush-collapseOne">
                                                What should I do if my transaction is delayed?
                                            </button>
                                        </h4>
                                        <div id="process1" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample2">
                                            <div className="accordion-body">If your transaction takes longer than expected, please check your email for any updates or requests for additional information. You can also contact our support team — we are ready to help you resolve the issue quickly.</div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#process2" aria-expanded="false" aria-controls="flush-collapseOne">
                                                How will I know when my exchange is complete?
                                            </button>
                                        </h4>
                                        <div id="process2" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample2">
                                            <div className="accordion-body">Once your exchange is complete, you will receive a confirmation email with all transaction details. You can also check the status directly in your Kittrow Investments s.r.o. account dashboard.</div>
                                        </div>
                                    </div>




                                </div>
                            </div>


                            {/* <!--=============================Question seprator!======================--> */}

                            <h2 className='sec-title'><img src='assets/images/payment.png' /> Payment & Fees</h2>
                            <div className='faq-quest'>
                                <div className="accordion accordion-flush" id="accordionFlushExample3">
                                    <div className="accordion-item">
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseseven" aria-expanded="false" aria-controls="flush-collapseOne">
                                                What fees does Kittrow Investments s.r.o. charge?
                                            </button>
                                        </h4>
                                        <div id="flush-collapseseven" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample3">
                                            <div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the first item’s accordion body.</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion accordion-flush" id="accordionFlushExample3">
                                    <div className="accordion-item">
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#payment2" aria-expanded="false" aria-controls="flush-collapseOne">
                                                What payout methods are available for fiat currency?
                                            </button>
                                        </h4>
                                        <div id="payment2" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample3">
                                            <div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the first item’s accordion body.</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion accordion-flush" id="accordionFlushExample3">
                                    <div className="accordion-item">
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#payment1" aria-expanded="false" aria-controls="flush-collapseOne">
                                                Why did I receive slightly less than expected?
                                            </button>
                                        </h4>
                                        <div id="payment1" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample3">
                                            <div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the first item’s accordion body.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {/* <!--=============================Question seprator!======================--> */}

                            <h2 className='sec-title'><img src='assets/images/security.png' /> Security & Privacy</h2>
                            <div className='faq-quest'>
                                <div className="accordion accordion-flush" id="accordionFlushExample4">
                                    <div className="accordion-item">
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#eight" aria-expanded="false" aria-controls="flush-collapseOne">
                                                Is Kittrow Investments s.r.o. safe to use?
                                            </button>
                                        </h4>
                                        <div id="eight" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample4">
                                            <div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the first item’s accordion body.</div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#security2" aria-expanded="false" aria-controls="flush-collapseOne">
                                                How do you protect my personal data?
                                            </button>
                                        </h4>
                                        <div id="security2" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample4">
                                            <div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the first item’s accordion body.</div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#security3" aria-expanded="false" aria-controls="flush-collapseOne">
                                                Does Kittrow Investments s.r.o. store my cryptocurrency?
                                            </button>
                                        </h4>
                                        <div id="security3" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample4">
                                            <div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the first item’s accordion body.</div>
                                        </div>
                                    </div>


                                </div>
                            </div>


                            {/* <!--=============================Question seprator!======================--> */}

                            <h2 className='sec-title'><img src='assets/images/support1.png' /> Support & Help</h2>
                            <div className='faq-quest' style={{border:"none"}}>
                                <div className="accordion accordion-flush" id="accordionFlushExample5">
                                    <div className="accordion-item" >
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#support" aria-expanded="false" aria-controls="flush-collapseOne">
                                                Who do I contact if I have an issue?
                                            </button>
                                        </h4>
                                        <div id="support" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample5">
                                            <div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the first item’s accordion body.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>



                {/* <!--===================help section!=================--> */}
                <div className='sec-pad-t'>
                    <div className='swap-part help-faq'>
                        <div className='row justify-content-center'>
                            <div className='col-xl-7 col-md-10'>

                                <h2>We’re here to help <br />every step of the way</h2>
                                <p>If you’re facing any issues or have questions — just reach out. Our support team replies fast and with care, even if it’s your first time dealing with crypto.</p>
                                <div className='button-group'>
                                    <Link to='/contact-us' className='btn lm-btn'>Contact support</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </section>

            <div className='sec-pad-t'></div>
            {/* <!--=============Spacer!===========--> */}
        </>
    );
}

export default FAQ;